import styled, { css } from 'styled-components';
import { cssColorValue, semanticColors, spacer16, spacer24, spacer32 } from '@spotify-internal/encore-web';

import { Vertical } from 'utils/vertical';

const defaultCardStyles = css`
  margin-top: ${spacer32};
  padding: ${spacer24} ${spacer16};
  border-radius: 8px;
  background: ${cssColorValue(semanticColors.backgroundElevatedHighlight)};
`;

const artistsCardStyles = css`
  margin-top: ${spacer32};
  padding-block: ${spacer24};
  background: ${cssColorValue(semanticColors.backgroundBase)};
`;

const StyledCard = styled.div<{ vertical?: Vertical }>`
  ${props => (props.vertical === Vertical.ARTISTS ? artistsCardStyles : defaultCardStyles)}
`;

export default StyledCard;
